import { render, staticRenderFns } from "./FormasAdquirir.vue?vue&type=template&id=311293b3&"
import script from "./FormasAdquirir.js?vue&type=script&lang=js&"
export * from "./FormasAdquirir.js?vue&type=script&lang=js&"
import style0 from "./FormasAdquirir.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports